import axios from "axios";
import { SERVER_URL } from "Constants";
import { EntityControllerData } from "./shared";
import { AbrOrAsicSearchResponse } from "Views/Components/JurisdictionBusinessEntitySearchBox/AustralianEntitySearchBox";
import { DataTypeSource } from "Models/Enums";


export type BusinessNumberDescriptionAu = {
	mapAbnEntityCodeToDescription: Record<string, string>;
	mapAcnEntityCodeToDescription: Record<string, string>;
	mapAcnEntityStatusToDescription: Record<string, string>;
};

export async function fetchBusinessNumberDescription() {
	const url = `${SERVER_URL}/api/BusinessNumber/au/descriptions`;
	return await axios.get<BusinessNumberDescriptionAu>(url);
}

export type ValidatedBusinessDetailsResponse = {
	abnExtraDetails?: ExtraEntityDetail
	acnExtraDetails?: ExtraEntityDetail
	error?: string;
}

export type ExtraEntityDetail = {
	// Entity Identifier Number
	identifierNumber?: string
	// Entity Status Code
	statusCode?: string;
	// Entity Type Code
	typeCode?: string;
	// Entity Name
	name?: string;
	source?: DataSourceDetails
}

export type DataSourceDetails = {
	timeStamp?: Date
	type: DataTypeSource,
}


export const AbnTypeCode = {
	// Sole trader / individual
	Individual: "IND"
}

export function verifyBusinessNumber(abn?: string | null, acn?: string | null): Promise<ValidatedBusinessDetailsResponse> {
	return axios.post(`${SERVER_URL}/api/BusinessNumber/au/find`, {
		abn: abn,
		acn: acn,
	}).then(data => {
		return data.data;
	}).catch(exception => {
		return { error: exception.response.data || "An error occurred while verifying the business number."  };
	});
}

export type NzBusinessQueryOption = {
	searchTerm: string,
	pageNo: number,
	pageSize: number
}

export type NzbnEntitySearchResponse = {
	nzbn: string;
	ncn: string;
	name: string;
	status: string;
	address: string;
}

export async function fetchNzBusinessSearch(queryOption: NzBusinessQueryOption) {
	const response = await axios.get<EntityControllerData<NzbnEntitySearchResponse>>(`${SERVER_URL}/api/BusinessNumber/nz/search`, {
		params: queryOption
	});
	return response;
}

export type AuBusinessQueryOption = {
	searchTerm: string,
	lookupMethod: "ABN" | "ACN" | null,
	pageNo: number,
	pageSize: number
}


export async function fetchAuBusinessSearch(queryOption: AuBusinessQueryOption) {
	const response = await axios.get<EntityControllerData<AbrOrAsicSearchResponse>>(`${SERVER_URL}/api/BusinessNumber/au/search`, {
		params: queryOption
	});
	return response;
}

